import { Button } from "components/DesignSystem/Button/Button";
import { Cell, flexRender, Row } from "react-table-8.10.7";
import { IncorporationTrackerRow } from "store/apis/incorporation";

type MobileIncorporationTrackerRowProps = {
  row: Row<IncorporationTrackerRow>;
  onClick: (row: IncorporationTrackerRow) => void;
};

// Column ids set on the column helpers in IncorporationTracker.
const TRACKER_COLUMN_ID = {
  GROUP_NAME: "company_group_name",
  TEMPLATE: "display_title",
  CURRENT_STAGE: "current_stage",
  NOTES: "notes",
} as const;

const renderCell = (cell?: Cell<IncorporationTrackerRow, unknown>) =>
  cell ? flexRender(cell.column.columnDef.cell, cell.getContext()) : null;

export const MobileIncorporationTrackerRow = ({
  row,
  onClick,
}: MobileIncorporationTrackerRowProps) => {
  const cellsById = Object.fromEntries(
    row.getVisibleCells().map((cell) => [cell.column.id, cell])
  );

  const handleClick = () => onClick(row.original);

  return (
    <div className="t-flex t-items-start t-gap-3 t-border-0 t-border-b t-border-solid t-border-neutral-0 t-py-3 last:t-border-b-0">
      <Button
        type="button"
        customType="ghost"
        onClick={handleClick}
        className="t-flex-1 t-min-w-0 !t-h-auto !t-px-0 !t-whitespace-normal t-text-left t-text-text-100 [&>div]:t-w-full [&>div]:t-justify-start [&>div>div]:t-w-full [&>div>div]:t-justify-start"
      >
        <div className="t-flex t-w-full t-flex-col t-gap-3">
          <div className="t-flex t-min-w-0">
            {renderCell(cellsById[TRACKER_COLUMN_ID.GROUP_NAME])}
          </div>

          <div className="t-flex t-flex-col t-gap-3 t-text-body-sm t-font-normal">
            <div className="t-flex t-min-w-0 t-flex-col t-items-start t-gap-1">
              <span className="t-text-text-30">Template</span>
              <div className="t-w-full t-min-w-0">
                {renderCell(cellsById[TRACKER_COLUMN_ID.TEMPLATE])}
              </div>
            </div>
            <div className="t-flex t-min-w-0 t-flex-col t-items-start t-gap-1">
              <span className="t-text-text-30">Current stage</span>
              {renderCell(cellsById[TRACKER_COLUMN_ID.CURRENT_STAGE])}
            </div>
          </div>
        </div>
      </Button>

      <div className="t-shrink-0">
        {renderCell(cellsById[TRACKER_COLUMN_ID.NOTES])}
      </div>
    </div>
  );
};
